<template>
  <div class="page_box">
    <div
      class="page_table_box"
      style="height:calc(100% - 10px);overflow-y: scroll;scrollbar-width: none;"
    >
      <div
        v-if="planInfo.content"
        v-html="planInfo.content"
      ></div>
      <div class="work_guide_content" v-else>
        <div>暂无内容</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EpidemicWorkGuide",
  data() {
    return {
      planInfo: {}
    };
  },
  methods: {
    async getInfo() {
      let res = await this.$Http.getEpidemicPlan({ type: 1 });
      if (res.code == 200) {
        this.planInfo = res.data.list[0] || {};
      } else if (res.code == 101) {
        this.planInfo = {};
      } else {
        this.planInfo = {};
        this.$message({
          type: "error",
          message: res.messsage || "工作指引获取失败"
        });
      }
    }
  },
  created() {},
  mounted() {
    this.getInfo();
  }
};
</script>

<style scoped>
@import "/css/epidemic_work_guide.css";
</style>
